import React from 'react'
import { convertToSafariCompatibleDate } from 'AccountsUtils'
import classes from './CalendarIcon.module.css'
import { isInFlyinDomain } from 'AccountsUtils'

const calendarIcon = ({ travelDate, isPast }) => {
  const dateObj = (dateStr => {
    let dateString = new Date(convertToSafariCompatibleDate(dateStr))
    dateString = dateString.toDateString()
    return dateString
  })(travelDate)
  const displayMonth = dateStr => {
    let month = ''
    if (dateStr) {
      month = dateObj.substr(4, 3)
    }
    return month
  }
  const displayDay = dateStr => {
    let day = ''
    if (dateStr) {
      day = dateObj.substr(0, 3)
    }
    return day
  }
  const { day, date, month, past } = classes
  const pastClass = isPast ? past : null
  const monthClassName = isInFlyinDomain() ? `${classes.flyinMonth}` : month
  return (
    <time className={pastClass}>
      <span
        className={monthClassName}
        style={{
          backgroundColor: isInFlyinDomain() ? '#194e91' : '',
          color: isInFlyinDomain() ? 'white' : ''
        }}
      >
        {displayDay(travelDate)}
      </span>
      <span className={date}>{dateObj.substr(8, 2)}</span>
      <span className={day}>{displayMonth(travelDate)}</span>
    </time>
  )
}

export default calendarIcon
